/**
 * TypePickerCell.js — Individual grid cell in the TypePickerGrid
 *
 * Shows a type name + short description. Click to select.
 */

import { cn } from '../../../../lib/utils';

const TypePickerCell = ({ type, description, onClick }) => (
  <button
    type="button"
    onClick={() => onClick(type)}
    className={cn(
      'text-left p-2 rounded-md border border-gray-700',
      'bg-gray-800/50 hover:bg-gray-700/70 hover:border-gray-500',
      'transition-colors cursor-pointer'
    )}
  >
    <div className="text-sm font-medium text-white">
      {type.replace(/_/g, ' ')}
    </div>
    <div className="text-xs text-gray-400 mt-0.5 line-clamp-2">
      {description}
    </div>
  </button>
);

export default TypePickerCell;
